import React from "react";
import styled from "styled-components";

export const PagePadding = styled.div`
  padding: ${({ padding }) => padding ?? "15px 10px"};
`;

const PageWrapper = ({ padding, children }) => (
  <PagePadding padding={padding}>
    {children}
  </PagePadding>
);

export default PageWrapper;
